export class NavigationLinkCategory {
    public open = false;

    public constructor(
        public index: number,
        public description: string,
        public rootLink: string | string[],
        public links: NavigationLink[],
    ) {}
}

export class NavigationLink {
    public constructor(
        public description: string,
        public routerLink: string | string[],
        public title: string = description,
    ) {}
}
